webpackJsonp([236347314162643],{

/***/ 329:
/***/ (function(module, exports) {

	module.exports = {"data":{"allMarkdownRemark":{"edges":[{"node":{"frontmatter":{"username":"Karim-Adnan","fullname":"Adnan Karim"}}}]}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---submissions-c8ac35ebcc910cae33ab.js